import en_US from '@/translations/en_US.json'
import pl_PL from '@/translations/pl_PL.json'
import de_DE from '@/translations/de_DE.json'
import en_GB from '@/translations/en_GB.json'
import { datetimeFormats } from '@/shared/i18n/formats/datetime'
import { FALLBACK_LOCALE as fallbackLocale } from '@/shared/config'

export default {
  globalInjection: true,
  legacy: false,
  locale: fallbackLocale,
  fallbackLocale,
  warnHtmlInMessage: false,
  messages: {
    'en-US': en_US,
    'en-GB': en_GB,
    'pl-PL': pl_PL,
    'de-DE': de_DE,
  },
  datetimeFormats: {
    'en-US': datetimeFormats(),
    'en-GB': datetimeFormats(),
    'pl-PL': datetimeFormats(),
    'de-DE': datetimeFormats(),
  },
  numberFormats: {},
}
